module.exports = __webpack_public_path__ + "static/img/bathroom2.093e83a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/bathroom2.jpg
// module id = w34y
// module chunks = 0